import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { Icon } from "../../../../components/Icon";
import { LinkBehaviour } from "../../../../components/LinkBehaviour";
import AccountIcon from "../../../../icons/account.svg";
import ArrowRight from "../../../../icons/arrow-right.svg";
import MailIcon from "../../../../icons/mail.svg";
import PhoneIcon from "../../../../icons/phone.svg";
import { useConfig } from "../../../../providers/useConfig";
import { formatPhoneNumber } from "../../../../utils/phoneFormatter/phoneFormatter";
import styles from "./ContactInfoBlock.module.scss";
export const CONTACT_INFO_BLOCK_ICONS = {
    Account: {
        icon: AccountIcon,
        iconProps: {
            width: "30px",
            height: "30px",
        },
    },
    Mail: {
        icon: MailIcon,
        iconProps: {
            width: "30px",
            height: "20px",
            viewBox: "0 0 30 20",
        },
    },
    Phone: {
        icon: PhoneIcon,
        iconProps: {
            width: "30px",
            height: "30px",
            viewBox: "0 0 30 30",
        },
    },
};
export const ContactInfoBlock = ({ info, additionalInfo, ctaLink, contactType }) => {
    const { icon, iconProps } = CONTACT_INFO_BLOCK_ICONS[contactType];
    const config = useConfig();
    const handleClick = () => {
        if (contactType === "Phone") {
            dispatchTrackingEvent(TrackingEvents.TrackingContactUsPhoneClick);
        }
        else {
            dispatchTrackingEvent(TrackingEvents.TrackingContactUsClick);
        }
    };
    const infoValue = contactType === "Phone" ? formatPhoneNumber(info || "", config.PHONE_FORMAT) : info;
    return (_jsxs(LinkBehaviour, { className: styles.link, href: ctaLink, onClick: handleClick, "data-testid": "contact-us-details-info-block", rel: "noreferrer", children: [_jsx(Icon, { restSvgProps: iconProps, className: styles.infoBlockIcon, ...iconProps, component: icon }), _jsxs("div", { className: styles.infoSection, children: [infoValue && _jsx("div", { className: styles.infoBlockSubInfo, children: infoValue }), additionalInfo && _jsx("div", { className: styles.infoBlockSubAdditionalInfo, children: additionalInfo })] }), _jsx(Icon, { className: styles.infoBlockCtaIcon, width: "50px", height: "50px", component: ArrowRight })] }));
};
//# sourceMappingURL=ContactInfoBlock.js.map